/**
 * Project dashboard
 *
 * Created by stefensuhat on 14/08/18 9.43 AM
 */

import { apiv2 } from 'utils';

export const query = (params) => apiv2.get('merchants', { params });

const defaultState = {
    items: [],
    item: {},
    meta: { total: 1, per_page: 15, current_page: 1 },
    errors: null,
};

export default {
    name: 'merchant',
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
        findResponse: (state, payload) => ({ ...state, item: payload.data }),
    },
    effects: {
        async fetch(params) {
            await apiv2.get('merchants', { params })
                .then((response) => this.fetchResponse(response));
        },
        async find(id) {
            await apiv2.get(`merchants/${id}`)
                .then((response) => this.findResponse(response));
        },
    },
};
